<template>
    <div class="front-page">
        <MenuBar2 v-show="!ism" />
        <div class="front_box">
            <img src="./img/titleBackground.png" alt="" style="width: 100%; height: 100%;">
        </div>
      
        <div class="content_box">
            <div class="toptitle">胜率排行榜</div>
            <div class="seep_box">
                <div class="seep_box_img">
                    <img src="./img/seek.png" alt="" style="width: 100%; height: 100%;">
                </div>
                <div class="seep_box_input">
                    <input type="text" placeholder="请输入选手姓名" v-model="seepInput">
                </div>
                <div style="color: #999999;">|</div>
                <div class="seep_box_btn" @click="seep">搜索</div>
            </div>

            <div class="content_box_content">
                <div class="content_box_title">
                    <div style="width: 25%;">排名</div>
                    <div style="width: 25%;">姓名</div>
                    <div style="width: 25%;">总场数</div>
                    <div style="width: 25%;">胜率</div>
                </div>

                <div class="content_box_content_list" ref="scrollBox">

                    <div class="list-item-box">
                        <div class="list_item" v-for="(item, index) in RankingData" :key="item.id"
                            :class="{ 'classBackground': index % 2 != 0 }">

                            <div class="ranking-img-box" v-if="item.ranking === 1">
                                <img class="ranking-img" src="./img/one.png" alt=""
                                    style="width: 1.375rem; height: 1.625rem;">
                            </div>

                            <div class="ranking-img-box" v-else-if="item.ranking === 2">
                                <img class="ranking-img" src="./img/two.png" alt=""
                                    style="width: 1.375rem; height: 1.625rem;">
                            </div>

                            <div class="ranking-img-box" v-else-if="item.ranking === 3">
                                <img class="ranking-img" src="./img/three.png" alt=""
                                    style="width: 1.375rem; height: 1.625rem;">
                            </div>
                                
                            <div style="width: 25%;" v-else > {{ item.ranking }}</div>
                          
                            <div style="width: 25%;color: #333333;">{{ item.user_name }}</div>
                            <div style="width: 25%;color: #3378EB;font-weight: 500;">{{ item.total }}</div>
                            <div style="width: 25%;color: #3378EB;font-weight: 500;">{{ item.win_rate}}%</div>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>

    <pop-page v-model:visible="showPop" />


</template>

<script setup>

import { getalluserwin } from '@/services/service'
import { ref, onMounted, nextTick,getCurrentInstance } from 'vue'

import BScroll from '@better-scroll/core'
import MenuBar2 from '@/components/MenuBar2.vue'
const scrollBox = ref(null)

import PopPage from '@/components/pop/pop-page.vue'

let scroll = null
var ism = ref(null)
onMounted(() => {

    const instance = getCurrentInstance();
    if(instance?.appContext.config.globalProperties.$isMobile()){
        ism.value = true;
    }else{
        ism.value = false;
    }
    nextTick(() => {
        scroll = new BScroll(scrollBox.value, {
            useTransition: true,
            click: true,
            mouseWheel: true,
        })
    })

})




var RankingData = ref(null);

onMounted(async () => {
    
     RankingData.value = await getalluserwin(5);
     console.log(RankingData.value);
     nextTick(() => {
        scroll.refresh();
    })
});

const seepInput = ref(sessionStorage.getItem('searchInput') || '')

const seep = async () => {
            const searchResult = await getalluserwin(5,seepInput.value)
            RankingData.value = searchResult

        nextTick(() => {
            scroll.refresh();
        })
}


const showPop = ref(false)

</script>

<style scoped lang="less">

.menu-container {
  display: flex;
  padding: 0;
  margin: 0;
  background: #f5f5f5;
  border-radius: 8px;
}

.menu-item {
  padding: 12px 24px;
  list-style: none;
  text-decoration: none;
  color: #333;
  transition: all 0.3s ease;
  position: relative;
}

.menu-item:hover {
  background: #e0e0e0;
}

/* 精确匹配时的样式 */
.menu-item.exact-active {
  color: #fff;
  background: #2196f3;
  border-radius: 8px;
}

/* 非精确匹配时的激活状态（嵌套路由） */
.menu-item.active:not(.exact-active) {
  color: #2196f3;
  font-weight: bold;
}
.front-page {
    width: 100vw;
    height: 100vh;
    background-color: #ebebeb;
    font-size: 16px;
    position: absolute;
    overflow: hidden;

    .front_box {
        width: 100%;
        height: 12.25rem;
    }
    .toptitle{
            font-size:2rem;
            color:white;
            font-weight:bold;
            width:80%;
            text-align:center;
            margin:1rem auto;
        }
    .content_box {
        width: 100%;
        height: 37.1875rem;
        // height: calc(100vh - 11.25rem);
        position: relative;
        top: -9.625rem;

        .seep_box {
            width: 90%;
            height: 2.5rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 0 auto;
            padding: 0 1rem;
            background-color: #F6F7F6;
            border-radius: 0.3125rem;

            .seep_box_img {
                width: 0.875rem;
                height: 0.875rem;
            }

            .seep_box_input {
                width: 13rem;
                height: 1.1563rem;
                line-height: 1.1563rem;

                input {
                    width: 100%;
                    height: 100%;
                    font-size: 1rem;
                    border: none;
                    outline: none;
                    background-color: #F6F7F6;

                }

            }

            .seep_box_btn {
                width: 3.5rem;
                height: 1.3438rem;
                font-size: 1rem;
                color: #3378EB;
                text-align: center;
            }
        }

        .content_box_content {
            width: 90%;
            background-color: #FFFFFF;
            margin: 0 auto;
            border-radius: 0.3125rem;
            margin-top: 1.25rem;

            .content_box_title {
                width: 100%;
                height: 2.5rem;
                font-weight: 700;
                margin: 0 auto;
                text-align: center;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .content_box_content_list {
                width: 100%;
                height: calc(100vh - 13.5rem);
                // height: 33.4375rem;
                overflow: hidden;




                .list-item-box {
                    .classBackground{
                        background-color: #f9f9f9;
                    }
                    width: 100%;
                }


                .list_item {
                    width: 100%;
                    height: 3.125rem;
                    margin: 0 auto;
                    text-align: center;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .ranking-img-box {
                        width: 25%;
                        height: 1.625rem;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }
        }
    }

}

</style>